import React from 'react';
import { ErrorMessage, useField } from 'formik';

import { EmailContainer, EmailInput, EmailLabel } from './Email.style';

export interface Props {
  placeholderText?: string;
  labelHtml: string;
  name: string;
  disabled?: boolean;
}

export const Email: React.FunctionComponent<Props> = ({
  placeholderText,
  labelHtml,
  name,
  disabled,
} : Props) => {
  const [field, meta] = useField(name);
  const isEmailInvalid = meta.error !== undefined && meta.touched;

  return (
    <EmailContainer>
      {isEmailInvalid
        ? <EmailLabel isEmailValid={false}><ErrorMessage name={name} /></EmailLabel>
        : <EmailLabel
          isEmailValid
          dangerouslySetInnerHTML={{ __html: labelHtml }}
        />
      }
      <EmailInput
        type="email"
        placeholder={placeholderText}
        isEmailValid={!isEmailInvalid}
        disabled={disabled}
        {...field}
      />
    </EmailContainer>
  );
};
